import { useEffect } from 'react';
import type { TutorLanguage } from 'src/types/tutorLanguage';

import { syncTutorUiLanguage } from '~ai-tutor/lib/i18n/syncTutorUiLanguage';

type TutorUiLanguageSyncProps = {
  language?: TutorLanguage;
};

export function TutorUiLanguageSync({ language }: TutorUiLanguageSyncProps) {
  useEffect(() => {
    // eslint-disable-next-line react-you-might-not-need-an-effect/no-event-handler
    if (language) {
      void syncTutorUiLanguage(language);
    }
  }, [language]);

  // rule is disabled because where this component is used it expects ReactNode not undefined
  // eslint-disable-next-line unicorn-x/no-null
  return null;
}
